<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="EVENT" name="event" v-if="iocDetailsContent && showEventCategory">
      <div v-if="!$_.isEmpty(iocDetailsContent.eventCategory)">
        <span class="subtitle2">Category</span>
        <span class="value">{{ iocDetailsContent.eventCategory }}</span>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.eventType)">
        <span class="subtitle2">Type</span>
        <span class="value">{{ iocDetailsContent.eventType }}</span>
      </div>
    </el-collapse-item>

    <linux-user-ioc-event-details v-if="operatingSystem === 'linux'" :ioc-details-content="iocDetailsContent" />
    <windows-user-ioc-event-details v-else :ioc-details-content="iocDetailsContent" />

    <el-collapse-item title="PROCESS" name="process" v-if="iocDetailsContent && showProcess">
      <div
        v-if="operatingSystem === 'linux' && !$_.isUndefined(iocDetailsContent.sourceSessionid)"
        :class="{
          'display-none': $_.isNumber(iocDetailsContent.sourceSessionid) && iocDetailsContent.sourceSessionid < 0
        }"
      >
        <span class="subtitle2">Session ID</span>
        <span class="value">{{ iocDetailsContent.sourceSessionid }}</span>
      </div>
      <div
        v-else-if="operatingSystem === 'linux' && !$_.isUndefined(iocDetailsContent.auditSessionId)"
        :class="{
          'display-none': $_.isNumber(iocDetailsContent.auditSessionId) && iocDetailsContent.auditSessionId < 0
        }"
      >
        <span class="subtitle2">Session ID</span>
        <span class="value">{{ iocDetailsContent.auditSessionId }}</span>
      </div>
      <div
        v-else
        :class="{ 'display-none': $_.isEmpty(iocDetailsContent.logonId) && !$_.isNumber(iocDetailsContent.logonId) }"
      >
        <span class="subtitle2">Login ID</span>
        <span class="value">{{ iocDetailsContent.logonId }}</span>
      </div>
      <div
        :class="{ 'display-none': $_.isEmpty(iocDetailsContent.logonip) && !$_.isNumber(iocDetailsContent.logonip) }"
      >
        <span class="subtitle2">Login IP</span>
        <span class="value">{{ iocDetailsContent.logonip }}</span>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.sourcePid) && !$_.isNumber(iocDetailsContent.sourcePid)
        }"
      >
        <span class="subtitle2">Pid</span>
        <span class="value">{{ iocDetailsContent.sourcePid }}</span>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.sourcePpid) && !$_.isNumber(iocDetailsContent.sourcePpid)
        }"
      >
        <span class="subtitle2">Parent Pid</span>
        <span class="value">{{ iocDetailsContent.sourcePpid }}</span>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.timestamp) && !$_.isNumber(iocDetailsContent.timestamp)
        }"
      >
        <span class="subtitle2">Start Time</span>
        <time class="value">{{ getDateTimeFormat(iocDetailsContent.timestamp) }}</time>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.rdpname)">
        <span class="subtitle2">RDP Session</span>
        <span class="value">{{ iocDetailsContent.rdpname }}</span>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.sourceProcessName)">
        <span class="subtitle2">Name</span>
        <span class="value cursor-pointer" @click="gotoThreatHunting('sourceProcessName')"
          >{{ iocDetailsContent.sourceProcessName }}
          <span class="material-icons" v-show="insightsEnabled"> search </span>
        </span>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.parentProcessName)">
        <span class="subtitle2">Parent Name</span>
        <span class="value">{{ iocDetailsContent.parentProcessName }}</span>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.sourceBinaryName)">
        <span class="subtitle2">Binary Path</span>
        <span class="value">{{ iocDetailsContent.sourceBinaryName }}</span>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.sourceCommandLine)">
        <span class="subtitle2">Command Line</span>
        <span class="value">{{ iocDetailsContent.sourceCommandLine }}</span>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.sourceProcessSha256Sum)">
        <span class="subtitle2">Binary Hash</span>
        <span class="value cursor-pointer">
          <a
            :href="`https://www.virustotal.com/gui/file/${iocDetailsContent.sourceProcessSha256Sum}/detection`"
            target="_blank"
            rel="noreferrer"
            >{{ getBinaryHashLabel(iocDetailsContent.sourceProcessSha256Sum) }}</a
          >
          <span
            class="display-inline-block icon-copy-to-clipboard cursor-pointer"
            @click="copyToClipboard(iocDetailsContent.sourceProcessSha256Sum)"
          >
          </span>
          <span class="material-icons" v-show="insightsEnabled" @click="gotoThreatHunting('sourceProcessSha256Sum')">
            search
          </span>
        </span>
      </div>
    </el-collapse-item>

    <el-collapse-item title="ARTIFACT" name="artifact" v-if="iocDetailsContent && showArtifacts">
      <div v-if="!$_.isEmpty(iocDetailsContent.artifactPath)">
        <span class="subtitle2">File Path</span>
        <span class="value cursor-pointer" @click="gotoThreatHunting('artifactPath')"
          >{{ iocDetailsContent.artifactPath }}
          <span class="material-icons" v-show="insightsEnabled"> search </span>
        </span>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.artifactSha256)" @click="gotoThreatHunting('artifactSha256')">
        <span class="subtitle2">File Hash</span>
        <span class="value cursor-pointer"
          >{{ iocDetailsContent.artifactSha256 }}
          <span class="material-icons" v-show="insightsEnabled"> search </span>
        </span>
      </div>
      <div
        :class="{
          'display-none':
            $_.isEmpty(iocDetailsContent.artifactBirthTime) && !$_.isNumber(iocDetailsContent.artifactBirthTime)
        }"
      >
        <span class="subtitle2">Create Time</span>
        <time class="value">{{ getDateTimeFormat(iocDetailsContent.artifactBirthTime) }}</time>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.major) && !$_.isNumber(iocDetailsContent.major)
        }"
      >
        <span class="subtitle2">Major</span>
        <span class="value">{{ iocDetailsContent.major }}</span>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.minor) && !$_.isNumber(iocDetailsContent.minor)
        }"
      >
        <span class="subtitle2">Minor</span>
        <span class="value">{{ iocDetailsContent.minor }}</span>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.inode) && !$_.isNumber(iocDetailsContent.inode)
        }"
      >
        <span class="subtitle2">Inode</span>
        <span class="value">{{ iocDetailsContent.inode }}</span>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.generation) && !$_.isNumber(iocDetailsContent.generation)
        }"
      >
        <span class="subtitle2">Generation</span>
        <span class="value">{{ iocDetailsContent.generation }}</span>
      </div>
    </el-collapse-item>

    <el-collapse-item title="SOCKET" name="socket" v-if="iocDetailsContent && showSockets">
      <div v-if="!$_.isEmpty(iocDetailsContent.socketFamily)">
        <span class="subtitle2">Family</span>
        <span class="value">{{ iocDetailsContent.socketFamily }}</span>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.localHost)">
        <span class="subtitle2">Local IP</span>
        <span class="value cursor-pointer" @click="gotoThreatHunting('localHost')"
          >{{ iocDetailsContent.localHost }}
          <span class="material-icons" v-show="insightsEnabled"> search </span>
        </span>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.localPort) && !$_.isNumber(iocDetailsContent.localPort)
        }"
      >
        <span class="subtitle2">Local Port</span>
        <span class="value">{{ iocDetailsContent.localPort }}</span>
      </div>
      <div v-if="!$_.isEmpty(iocDetailsContent.remoteHost)">
        <span class="subtitle2">Remote IP</span>
        <span class="value cursor-pointer" @click="gotoThreatHunting('remoteHost')"
          >{{ iocDetailsContent.remoteHost }}
          <span class="material-icons" v-show="insightsEnabled"> search </span>
        </span>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.remotePort) && !$_.isNumber(iocDetailsContent.remotePort)
        }"
      >
        <span class="subtitle2">Remote Port</span>
        <span class="value">{{ iocDetailsContent.remotePort }}</span>
      </div>
      <div v-if="iocDetailsContent && !$_.isEmpty(iocDetailsContent.externalIPIntelMetadata)">
        <span class="subtitle2">Remote IP Location</span>
        <span class="value"
          >{{ iocDetailsContent.externalIPIntelMetadata.city }},
          {{ iocDetailsContent.externalIPIntelMetadata.subdivision }}
          {{ iocDetailsContent.externalIPIntelMetadata.country }} {{ iocDetailsContent.externalIPIntelMetadata.postal }}
          <br />
          ({{ iocDetailsContent.externalIPIntelMetadata.latitude }},{{
            iocDetailsContent.externalIPIntelMetadata.longitude
          }})
        </span>
      </div>
    </el-collapse-item>

    <el-collapse-item
      title="EVENT METADATA"
      name="meta_metadata"
      v-if="iocDetailsContent && !$_.isEmpty(iocDetailsContent.infEventMetadataMultiMap)"
      class="ml-metadata"
    >
      <div v-for="(title, multiKey) in iocDetailsContent.infEventMetadataMultiMap.metadataMultiMapKeys" :key="multiKey">
        <div v-if="$_.has(iocDetailsContent.infEventMetadataMultiMap, multiKey)">
          <h6>{{ title }}</h6>
          <div
            class="ml-metadata_block"
            v-for="(propTitle, metaKey) in iocDetailsContent.infEventMetadataMultiMap.metadataMapKeys"
            :key="propTitle"
          >
            <div v-if="$_.has(iocDetailsContent.infEventMetadataMultiMap, [multiKey, metaKey])">
              <span class="subtitle2">{{ propTitle }}</span>
              <time class="value" v-if="metaKey === 'timestamp'">{{
                getDateTimeFormat(iocDetailsContent.infEventMetadataMultiMap[multiKey][metaKey])
              }}</time>
              <span class="value" v-else>{{ iocDetailsContent.infEventMetadataMultiMap[multiKey][metaKey] }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-collapse-item>

    <el-collapse-item
      title="THREAT INTEL"
      name="threat_intel_metadata"
      v-if="iocDetailsContent && !$_.isEmpty(iocDetailsContent.threatIntelMetadata)"
      class="threatintel-metadata"
    >
      <div
        class="threatintel-metadata_block"
        v-for="(metadata, idx) in threatIntelMetainfo"
        :key="idx"
        :class="{ 'display-none': $_.isEmpty(metadata.value) && !$_.isNumber(metadata.value) }"
      >
        <span
          class="subtitle2"
          :class="{
            capitalize: $_.indexOf(['ip', 'vpn', 'os'], metadata.title) < 0,
            uppercase: $_.indexOf(['ip', 'vpn', 'os'], metadata.title) > -1
          }"
          >{{ metadata.title }}</span
        >
        <span class="value">{{ metadata.value }}</span>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'

import { NANOSECONDS_TO_MILLISECONDS, DATETIME_FORMAT } from '@/constants/datetime.constants'

import WindowsUserIocEventDetails from '@/components/feed/ioc-details/WindowsUserIocEventDetails.vue'
import LinuxUserIocEventDetails from '@/components/feed/ioc-details/LinuxUserIocEventDetails.vue'

export default {
  name: 'IocEventDetailsContent',
  props: {
    iocDetailsContent: {
      default: () => {
        return {}
      },
      type: [Object]
    },
    operatingSystem: {
      default: 'linux',
      type: String
    }
  },
  data () {
    return {
      activeNames: ['event', 'process'],
      dateformat: DATETIME_FORMAT,
      nsToMsec: NANOSECONDS_TO_MILLISECONDS
    }
  },
  computed: {
    ...mapGetters(['insightsEnabled']),
    showEventCategory: function () {
      let eventFields = ['eventCategory', 'eventType']
      return this.isSectionValuePresent(this.iocDetailsContent, eventFields)
    },
    showProcess: function () {
      let processFields = [
        'sourcePid',
        'sourcePpid',
        'timestamp',
        'sourceProcessName',
        'parentProcessName',
        'sourceBinaryName',
        'sourceCommandLine'
      ]
      return this.isSectionValuePresent(this.iocDetailsContent, processFields)
    },
    showArtifacts: function () {
      let artifactFields = [
        'artifactPath',
        'artifactBirthTime',
        'artifactSha256',
        'major',
        'minor',
        'inode',
        'generation'
      ]
      return this.isSectionValuePresent(this.iocDetailsContent, artifactFields)
    },
    showSockets: function () {
      let socketFields = ['socketFamily', 'localHost', 'localPort', 'remoteHost', 'remotePort']
      return this.isSectionValuePresent(this.iocDetailsContent, socketFields)
    },
    threatIntelMetainfo: function () {
      let metainfo = []
      for (let key in this.iocDetailsContent.threatIntelMetadata) {
        let value = this.iocDetailsContent.threatIntelMetadata[key]
        // only 1 level of nested object
        if (_.isObject(value) && !_.isArray(value)) {
          for (let objKey in this.iocDetailsContent.threatIntelMetadata[key]) {
            value = this.iocDetailsContent.threatIntelMetadata[key][objKey]
            if (_.isArray(value)) {
              value = value.join(', ')
            }
            this.pushTitleValue(metainfo, objKey, value)
          }
        } else {
          if (_.isArray(value)) {
            value = value.join(', ')
          }
          this.pushTitleValue(metainfo, key, value)
        }
      }
      return metainfo
    }
  },
  methods: {
    pushTitleValue (infolist, title, value) {
      title = title.replace(/_/g, ' ')
      infolist.push({
        title: title,
        value: value
      })
    },
    getDateTimeFormat (tmstp) {
      return this.$moment(tmstp * NANOSECONDS_TO_MILLISECONDS).format(DATETIME_FORMAT)
    },
    isSectionValuePresent (objDetails, fields) {
      for (var idx in fields) {
        // if field is not empty - return true to display section
        if (!_.isEmpty(objDetails[fields[idx]])) {
          return true
        }
      }
      return false
    },
    gotoThreatHunting (field) {
      if (!this.insightsEnabled) {
        return false
      }
      let startTimeHrBefore = moment(this.iocDetailsContent.seenTime).subtract({ days: 7 })
      let startTimeHrAfter = moment(this.iocDetailsContent.seenTime)
      let threatHuntParam = `start_time:${startTimeHrBefore.toISOString()}+end_time:${startTimeHrAfter.toISOString()}`
      switch (field) {
        case 'artifactSha256':
          threatHuntParam = `${threatHuntParam}+edgeName:in:exec+sourceSha256sum:eq:${this.iocDetailsContent.artifactSha256}+agentId:eq:${this.iocDetailsContent.agentId}`
          break
        case 'artifactPath':
          threatHuntParam = `${threatHuntParam}+edgeName:in:exec:file+targetPathName:eq:${this.iocDetailsContent.artifactPath}+agentId:eq:${this.iocDetailsContent.agentId}`
          break
        case 'localHost':
          threatHuntParam = `${threatHuntParam}+edgeName:in:exec:network+sourceAddr:eq:${this.iocDetailsContent.localHost}+agentId:eq:${this.iocDetailsContent.agentId}`
          break
        case 'remoteHost':
          threatHuntParam = `${threatHuntParam}+edgeName:in:exec:network+destAddr:eq:${this.iocDetailsContent.remoteHost}+agentId:eq:${this.iocDetailsContent.agentId}`
          break
        case 'sourceProcessSha256Sum':
          threatHuntParam = `${threatHuntParam}+edgeName:in:exec+sourceSha256sum:eq:${this.iocDetailsContent.sourceProcessSha256Sum}+agentId:eq:${this.iocDetailsContent.agentId}`
          break
        default:
          threatHuntParam = `${threatHuntParam}+edgeName:in:exec:file:network:system:user+sourceComm:eq:${this.iocDetailsContent.sourceProcessName}+agentId:eq:${this.iocDetailsContent.agentId}`
          break
      }

      this.$router.push({
        name: 'threat-hunting',
        query: { search: threatHuntParam }
      })
    },
    getBinaryHashLabel (val) {
      if (val && !_.isNull(val) && val.toLowerCase() !== 'null') {
        return `(${val.substring(0, 12)})`
      }
      return ''
    },
    copyToClipboard (hashValue) {
      navigator.clipboard.writeText(hashValue).then(
        () => {
          this.$alert({
            width: '400',
            type: 'success',
            duration: 3000,
            text: 'Successfully copied to clipboard'
          })
        },
        err => {
          this.$alert({
            width: '400',
            type: 'error',
            duration: 3000,
            text: `Error while copying to clipboard: ${err}`
          })
        }
      )
    }
  },
  components: {
    WindowsUserIocEventDetails,
    LinuxUserIocEventDetails
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.el-collapse {
  overflow: scroll;
  border-bottom: none;
}

>>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  background-color: var(--gray-50);
  border-bottom: 1px solid var(--border-color);
  padding-left: 15px;
  font-size: 10px;
  font-weight: normal;
  color: inherit;
  line-height: 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.el-collapse-item >>> .el-collapse-item__content,
.ml-metadata_block,
.threatintel-metadata_block {
  > div {
    display: flex;
    flex-wrap: nowrap;
    padding: 10px;

    > .subtitle2,
    .value {
      flex-grow: 1;
      align-self: auto;
      width: 50%;

      .material-icons {
        font-size: 16px;
        vertical-align: text-bottom;
      }
    }
  }
}

.ml-metadata_block {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/feed/ioc-details/IocEventDetailsContent.vue